import React from 'react';
import { Shield } from 'lucide-react';
import PolicyLayout, { Section, P, Li, Ul } from './PolicyLayout';

export default function PrivacyPage() {
  return (
    <PolicyLayout
      title="Privacy Policy"
      subtitle="How we collect, use and protect your information"
      icon={Shield}
    >
      <Section title="Information We Collect">
        <Ul>
          <Li>
            <strong style={{ color: '#fff' }}>Personal Information:</strong> Name, mobile number,
            date of birth, gender, and profile photo.
          </Li>
          <Li>
            <strong style={{ color: '#fff' }}>Financial Information:</strong> Bank account details,
            UPI ID, and investment/withdrawal transaction history.
          </Li>
          <Li>
            <strong style={{ color: '#fff' }}>Identity Documents:</strong> Government-issued ID
            proof (Aadhaar, PAN, Passport, etc.) for KYC verification.
          </Li>
          <Li>
            <strong style={{ color: '#fff' }}>Usage Data:</strong> Device type, IP address, and
            app usage patterns used for security and analytics purposes.
          </Li>
        </Ul>
      </Section>

      <Section title="How We Use Your Information">
        <Ul>
          <Li>To create and manage your investment account.</Li>
          <Li>To process investments, withdrawals, and gold redemption requests.</Li>
          <Li>To verify your identity (KYC) as required by financial regulations.</Li>
          <Li>To send transaction confirmations and important account alerts.</Li>
          <Li>To prevent fraud and ensure Platform security.</Li>
          <Li>To comply with legal and regulatory obligations under Indian law.</Li>
        </Ul>
      </Section>

      <Section title="Data Sharing">
        <P>We do not sell your personal data. We may share data only with:</P>
        <Ul>
          <Li>
            <strong style={{ color: '#fff' }}>Razorpay:</strong> Our payment gateway for
            processing transactions securely. Governed by Razorpay's own Privacy Policy.
          </Li>
          <Li>
            <strong style={{ color: '#fff' }}>Banks:</strong> For processing withdrawals and
            transfers to your registered bank account.
          </Li>
          <Li>
            <strong style={{ color: '#fff' }}>Regulatory Authorities:</strong> When required by
            law, such as the Income Tax Department or other Indian regulatory bodies.
          </Li>
        </Ul>
      </Section>

      <Section title="Data Security">
        <Ul>
          <Li>All data is transmitted over HTTPS using TLS encryption.</Li>
          <Li>Passwords are hashed using industry-standard algorithms and never stored in plain text.</Li>
          <Li>Payment data is handled exclusively by Razorpay and is PCI-DSS compliant.</Li>
          <Li>Access to your personal data is restricted to authorised personnel only.</Li>
          <Li>We conduct regular security reviews and vulnerability assessments.</Li>
        </Ul>
      </Section>

      <Section title="Data Retention">
        <P>
          We retain your personal data for as long as your account is active or as required by
          applicable law. You may request deletion of your account; however, transaction records
          may be retained for up to 7 years as required by Indian financial regulations.
        </P>
      </Section>

      <Section title="Your Rights">
        <Ul>
          <Li>Request access to the personal data we hold about you.</Li>
          <Li>Request correction of inaccurate or outdated information.</Li>
          <Li>Request deletion of your account and associated personal data.</Li>
          <Li>Withdraw consent for marketing communications at any time.</Li>
          <Li>Lodge a complaint with the relevant data protection authority.</Li>
        </Ul>
      </Section>

      <Section title="Cookies">
        <P>
          We use minimal, essential cookies for session management and security only.
          We do not use third-party advertising or tracking cookies.
        </P>
      </Section>

      <Section title="Contact for Privacy Concerns">
        <P>Data Protection Officer: privacy@shinejewellery.in</P>
        <P>Response time: Within 72 hours of receiving your request.</P>
      </Section>
    </PolicyLayout>
  );
}
